import React from 'react';
import '../../styles/PartnerWithUs.css';

function PartnerMotivationPunchline() {
  return (
    <section className="partnerPunchline">
      <p>
        If your answer is <strong>“YES”</strong>, a career in <strong>ERA</strong> is the{' '}
        <strong>RIGHT CHOICE for YOU</strong>.
      </p>
    </section>
  );
}

export default PartnerMotivationPunchline;
